<template>
  <div class="news-detail-page"> <!-- 1. 顶部Banner（复用新闻列表页Banner） -->
    <section class="hidden md:block relative w-full overflow-hidden"> <img src="@/assets/news/Group_26.png"
        alt="蘑菇产业红利新闻速览" class="w-full h-full object-cover">
      <div class="absolute inset-0 text-center top-[20%] text-white z-10">
        <h1 class="text-[clamp(2.5rem,5vw,4rem)] font-bold mb-3">蘑菇产业红利新闻速览</h1>
        <p class="text-[clamp(0.9rem,2vw,1rem)] max-w-lg text-center px-4 mx-auto"> 政策+市场双轮驱动，蘑菇产业迎黄金增长期</p>
      </div>
    </section> <!-- 2. 新闻详情内容区 -->
    <section v-if="id == 1" class="md:py-16 py-6  md:max-w-[56%] max-w-[94%] mx-auto px-4"> <!-- 标题栏 -->
      <div class="flex justify-between items-center mb-8">
        <div class="flex items-center gap-2"> <!-- 设计图左侧：只有文字，去掉多余圆点图标 --> <svg t="1776759085485"
            class="hidden md:block icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="3598" width="32" height="32">
            <path
              d="M469.333333 60.693333a85.333333 85.333333 0 0 1 85.333334 0l326.826666 188.714667a85.333333 85.333333 0 0 1 42.666667 73.898667v377.386666a85.333333 85.333333 0 0 1-42.666667 73.898667L554.666667 963.306667a85.333333 85.333333 0 0 1-85.333334 0L142.506667 774.592a85.333333 85.333333 0 0 1-42.666667-73.898667v-377.386666a85.333333 85.333333 0 0 1 42.666667-73.898667z m42.666667 73.898667L185.173333 323.306667v377.386666L512 889.408l326.826667-188.714667v-377.386666L512 134.592zM512 341.333333a170.666667 170.666667 0 1 1 0 341.333334 170.666667 170.666667 0 0 1 0-341.333334z m0 85.333334a85.333333 85.333333 0 1 0 0 170.666666 85.333333 85.333333 0 0 0 0-170.666666z"
              fill="#999999" p-id="3599"></path>
          </svg> <svg t="1776759085485" class="md:hidden block icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="3598" width="16" height="16">
            <path
              d="M469.333333 60.693333a85.333333 85.333333 0 0 1 85.333334 0l326.826666 188.714667a85.333333 85.333333 0 0 1 42.666667 73.898667v377.386666a85.333333 85.333333 0 0 1-42.666667 73.898667L554.666667 963.306667a85.333333 85.333333 0 0 1-85.333334 0L142.506667 774.592a85.333333 85.333333 0 0 1-42.666667-73.898667v-377.386666a85.333333 85.333333 0 0 1 42.666667-73.898667z m42.666667 73.898667L185.173333 323.306667v377.386666L512 889.408l326.826667-188.714667v-377.386666L512 134.592zM512 341.333333a170.666667 170.666667 0 1 1 0 341.333334 170.666667 170.666667 0 0 1 0-341.333334z m0 85.333334a85.333333 85.333333 0 1 0 0 170.666666 85.333333 85.333333 0 0 0 0-170.666666z"
              fill="#999999" p-id="3599"></path>
          </svg> <span class="text-[#999] md:text-base text-[16px]">菌丰新闻</span> </div>
        <div class="flex items-center gap-4"> <!-- 返回按钮样式对齐设计图：< 返回 箭头+文字 --> <button @click="$router.go(-1)"
            class="text-[#999] md:text-base text-[16px] flex items-center gap-1"> <span>‹</span> 返回
          </button> <svg t="1776759203352" class="hidden md:block icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="5508" width="32" height="32">
            <path
              d="M826.48 660.9c-60.456 0-109.88 32.358-132.9 82.596L401.373 619.203c17.045-26.404 26.41-58.768 26.41-93.666 0-14.459-1.706-28.943-5.12-42.573l186.572-144.752c24.72 18.729 56.253 29.798 91.177 29.798 84.347 0 147.38-63.012 147.38-146.432 0-83.45-63.054-146.462-147.38-146.462-84.352 0-146.535 63.011-146.535 146.462 0 21.29 4.265 40.868 11.07 57.892L392.837 411.433c-34.068-51.087-90.301-86.856-154.194-86.856-104.192-0.26-188.866 83.989-189.122 188.18a23.803 23.803 0 0 0 0 0.856c-0.2 104.192 84.106 188.815 188.298 189.015h0.83c39.188 0 75.811-10.194 105.635-28.928l335.683 143.032c4.27 79.176 65.602 137.923 146.509 137.923 84.372 0 146.554-62.992 146.554-146.437s-63.058-147.313-146.529-147.313h-0.02z"
              p-id="5509" fill="#999999"></path>
          </svg> <svg t="1776759203352" class="md:hidden block icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="5508" width="16" height="16">
            <path
              d="M826.48 660.9c-60.456 0-109.88 32.358-132.9 82.596L401.373 619.203c17.045-26.404 26.41-58.768 26.41-93.666 0-14.459-1.706-28.943-5.12-42.573l186.572-144.752c24.72 18.729 56.253 29.798 91.177 29.798 84.347 0 147.38-63.012 147.38-146.432 0-83.45-63.054-146.462-147.38-146.462-84.352 0-146.535 63.011-146.535 146.462 0 21.29 4.265 40.868 11.07 57.892L392.837 411.433c-34.068-51.087-90.301-86.856-154.194-86.856-104.192-0.26-188.866 83.989-189.122 188.18a23.803 23.803 0 0 0 0 0.856c-0.2 104.192 84.106 188.815 188.298 189.015h0.83c39.188 0 75.811-10.194 105.635-28.928l335.683 143.032c4.27 79.176 65.602 137.923 146.509 137.923 84.372 0 146.554-62.992 146.554-146.437s-63.058-147.313-146.529-147.313h-0.02z"
              p-id="5509" fill="#999999"></path>
          </svg> <!-- 设计图无右侧⇄按钮，直接移除 --> </div>
      </div> <!-- 新闻标题（完全对齐设计图：绿色、居中、字号加粗） -->
      <h2 class="md:text-3xl text-[16px] font-bold text-[#41B56F] text-center mb-8"> 总投资2亿元，占地150亩，又一大型食用菌项目正式签约！
      </h2> <!-- 正文内容（完全对齐设计图排版、行距、图片、注释、底部编辑） -->
      <div class="text-[#000] md:text-xl text-[14px] tracking-wide leading-loose space-y-4 text-gray-600 indent-8">
        <p> 近日，北京菌丰生物科技有限公司智能食用菌仿生仓立体种植农业项目正式签约，落户重庆江津江津区白沙镇。该项目总投2亿元，占地150亩，共分两期建设，全部达产后可年产食用菌5万吨。</p>
        <p> 所谓仿生种植是模拟自然生态系统和生物原生环境，还原生物适宜的生长条件，减少人工干预，提升品质与产量等。通过菇智慧立体仿生仓，可模拟食用菌生长所需的温、光、湿、气等条件，并通过智能调控系统实时调节。</p>
        <p>
          近年来智慧方舱在食用菌生产过程中的应用日益普遍，和传统种植模式相比，具有空间灵活布置、不受季节气候条件制约、提升空间利用率及产品产量和品质、降低劳动强度、提高产品经济效益等优势。随着智慧方舱的普及应用，有力推动了传统生产模式向智能化、集约化等方向转型升级，进而推动食用菌产业高质量发展。
        </p> <!-- 底部编辑信息（对齐设计图：靠右、格式、文字） -->
        <div class="text-right md:text-base text-[16px] text-[#999] mt-12"> <i class="el-icon-edit-outline"></i>
          <span>编辑 菌丰生物</span> </div>
      </div>
    </section>
    <section v-if="id == 2" class="md:py-16 py-6  md:max-w-[56%] max-w-[94%] mx-auto px-4"> <!-- 标题栏 -->
      <div class="flex justify-between items-center mb-8">
        <div class="flex items-center gap-2"> <!-- 设计图左侧：只有文字，去掉多余圆点图标 --> <svg t="1776759085485"
            class="hidden md:block icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="3598" width="32" height="32">
            <path
              d="M469.333333 60.693333a85.333333 85.333333 0 0 1 85.333334 0l326.826666 188.714667a85.333333 85.333333 0 0 1 42.666667 73.898667v377.386666a85.333333 85.333333 0 0 1-42.666667 73.898667L554.666667 963.306667a85.333333 85.333333 0 0 1-85.333334 0L142.506667 774.592a85.333333 85.333333 0 0 1-42.666667-73.898667v-377.386666a85.333333 85.333333 0 0 1 42.666667-73.898667z m42.666667 73.898667L185.173333 323.306667v377.386666L512 889.408l326.826667-188.714667v-377.386666L512 134.592zM512 341.333333a170.666667 170.666667 0 1 1 0 341.333334 170.666667 170.666667 0 0 1 0-341.333334z m0 85.333334a85.333333 85.333333 0 1 0 0 170.666666 85.333333 85.333333 0 0 0 0-170.666666z"
              fill="#999999" p-id="3599"></path>
          </svg> <svg t="1776759085485" class="md:hidden block icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="3598" width="16" height="16">
            <path
              d="M469.333333 60.693333a85.333333 85.333333 0 0 1 85.333334 0l326.826666 188.714667a85.333333 85.333333 0 0 1 42.666667 73.898667v377.386666a85.333333 85.333333 0 0 1-42.666667 73.898667L554.666667 963.306667a85.333333 85.333333 0 0 1-85.333334 0L142.506667 774.592a85.333333 85.333333 0 0 1-42.666667-73.898667v-377.386666a85.333333 85.333333 0 0 1 42.666667-73.898667z m42.666667 73.898667L185.173333 323.306667v377.386666L512 889.408l326.826667-188.714667v-377.386666L512 134.592zM512 341.333333a170.666667 170.666667 0 1 1 0 341.333334 170.666667 170.666667 0 0 1 0-341.333334z m0 85.333334a85.333333 85.333333 0 1 0 0 170.666666 85.333333 85.333333 0 0 0 0-170.666666z"
              fill="#999999" p-id="3599"></path>
          </svg> <span class="text-[#999] md:text-base text-[16px]">菌丰新闻</span> </div>
        <div class="flex items-center gap-4"> <!-- 返回按钮样式对齐设计图：< 返回 箭头+文字 --> <button @click="$router.go(-1)"
            class="text-[#999] md:text-base text-[16px] flex items-center gap-1"> <span>‹</span> 返回
          </button> <svg t="1776759203352" class="hidden md:block icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="5508" width="32" height="32">
            <path
              d="M826.48 660.9c-60.456 0-109.88 32.358-132.9 82.596L401.373 619.203c17.045-26.404 26.41-58.768 26.41-93.666 0-14.459-1.706-28.943-5.12-42.573l186.572-144.752c24.72 18.729 56.253 29.798 91.177 29.798 84.347 0 147.38-63.012 147.38-146.432 0-83.45-63.054-146.462-147.38-146.462-84.352 0-146.535 63.011-146.535 146.462 0 21.29 4.265 40.868 11.07 57.892L392.837 411.433c-34.068-51.087-90.301-86.856-154.194-86.856-104.192-0.26-188.866 83.989-189.122 188.18a23.803 23.803 0 0 0 0 0.856c-0.2 104.192 84.106 188.815 188.298 189.015h0.83c39.188 0 75.811-10.194 105.635-28.928l335.683 143.032c4.27 79.176 65.602 137.923 146.509 137.923 84.372 0 146.554-62.992 146.554-146.437s-63.058-147.313-146.529-147.313h-0.02z"
              p-id="5509" fill="#999999"></path>
          </svg> <svg t="1776759203352" class="md:hidden block icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="5508" width="16" height="16">
            <path
              d="M826.48 660.9c-60.456 0-109.88 32.358-132.9 82.596L401.373 619.203c17.045-26.404 26.41-58.768 26.41-93.666 0-14.459-1.706-28.943-5.12-42.573l186.572-144.752c24.72 18.729 56.253 29.798 91.177 29.798 84.347 0 147.38-63.012 147.38-146.432 0-83.45-63.054-146.462-147.38-146.462-84.352 0-146.535 63.011-146.535 146.462 0 21.29 4.265 40.868 11.07 57.892L392.837 411.433c-34.068-51.087-90.301-86.856-154.194-86.856-104.192-0.26-188.866 83.989-189.122 188.18a23.803 23.803 0 0 0 0 0.856c-0.2 104.192 84.106 188.815 188.298 189.015h0.83c39.188 0 75.811-10.194 105.635-28.928l335.683 143.032c4.27 79.176 65.602 137.923 146.509 137.923 84.372 0 146.554-62.992 146.554-146.437s-63.058-147.313-146.529-147.313h-0.02z"
              p-id="5509" fill="#999999"></path>
          </svg> <!-- 设计图无右侧⇄按钮，直接移除 --> </div>
      </div> <!-- 新闻标题（完全对齐设计图：绿色、居中、字号加粗） -->
      <h2 class="md:text-3xl text-[16px] font-bold text-[#41B56F] text-center mb-8"> 可食用！成都再次发现新的菌种
      </h2> <!-- 正文内容（完全对齐设计图排版、行距、图片、注释、底部编辑） -->
      <div class="text-[#000] md:text-xl text-[14px] tracking-wide leading-loose space-y-4 text-gray-600 indent-8">
        <p> 今日，记者从金堂县获悉，西南科技大学生命科学与农林学院教授（退休）——贺新生在金堂县赵家镇意外发现了野生草菇菌种，它不仅打破了草菇生长的传统季节限制，更具有独特的低温适应性。
        </p> <!-- 第一张配图（完全保留你的图片路径） -->
        <div class="my-8 text-center"> <img src="@/assets/news/Rectangle_17.png" alt="新发现的低温型草菇"
            class="w-[80%] mx-auto rounded shadow-sm block">
          <p class="text-xs text-[#666] mt-2 text-center w-full  indent-0">▲ 新发现的低温型草菇</p>
        </div>
        <p> 金堂县一直以来都是食用菌生长的乐园。继羊肚菌之后，这里再次发现了新的食用菌品种——低温型草菇。这一发现证明了金堂独特的气候条件和生态环境非常适合食用菌的生长，也为成都的食用菌产业增添了新的亮点。
        </p>
        <p>
          贺教授介绍称：“传统上，草菇的种植受到季节和温度的严格限制。在大多数地区，草菇主要在夏季的6月至9月之间种植，因为这段时间的气温通常维持在25℃至35℃之间，是草菇生长的最佳温度范围。然而，随着冬季的到来，气温逐渐下降，草菇的生长也随之停止。为了在冬季继续生产草菇，许多种植者不得不采取加热措施来提高大棚内的温度，但这无疑增加了生产成本。”
        </p>
        <p>
          贺教授发现的这种低温型草菇则完全改变了这一局面。它能够在较低的温度下正常生长，甚至能在金堂11月份这样的深秋季节依然保持旺盛的生长势头。这意味着，通过合理的栽培管理，可以在冬季甚至早春时节收获新鲜的草菇，从而打破季节的限制，满足市场对新鲜草菇的持续需求。
        </p> <!-- 第二张配图（完全保留你的图片路径） -->
        <div class="my-8 text-center"> <img src="@/assets/news/Rectangle_47.png" alt="采摘后能保持较长时间的新鲜度"
            class="w-[80%] mx-auto rounded shadow-sm block">
          <p class="text-xs text-[#666] mt-2  indent-0">▲ 采摘后能保持较长时间的新鲜度</p>
        </div>
        <p>
          值得一提的是，这次发现的草菇是在纯木屑上生长的，这与传统的稻草、棉渣栽培方式有所不同。金堂县可以利用自身的资源优势，如树枝条木屑或山上的灌木树枝木屑等进行栽培尝试，这不仅为草菇的栽培提供了新的基质选择，也有助于减少农业废弃物实现资源的循环利用。
        </p>
        <p> 除了低温适应性外，这种新型草菇还有一个显著的优势：它的货架寿命得到了显著延长。
        </p>
        <p>
          传统草菇在采摘后往往只能保存几个小时就会开伞变质，失去商品价值。这种低温型草菇由于生长速度较慢且细胞结构更加紧密，因此在采摘后能够保持较长时间的新鲜度。这种草菇在采摘后可以保存一到两天甚至更久的时间而不变质。这对于消费者来说无疑是一个好消息，因为他们可以购买到更加新鲜、品质更好的草菇产品；而对于商家来说，这也意味着他们的产品能够在市场上停留更长的时间，从而有更多机会被消费者选购。
        </p> <!-- 底部编辑信息（对齐设计图：靠右、格式、文字） -->
        <div class="text-right md:text-base text-[16px] text-[#999] mt-12"> <i class="el-icon-edit-outline"></i>
          <span>编辑 菌丰生物</span> </div>
      </div>
    </section>
    <section v-if="id == 3" class="md:py-16 py-6  md:max-w-[56%] max-w-[94%] mx-auto px-4"> <!-- 标题栏 -->
      <div class="flex justify-between items-center mb-8">
        <div class="flex items-center gap-2"> <!-- 设计图左侧：只有文字，去掉多余圆点图标 --> <svg t="1776759085485"
            class="hidden md:block icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="3598" width="32" height="32">
            <path
              d="M469.333333 60.693333a85.333333 85.333333 0 0 1 85.333334 0l326.826666 188.714667a85.333333 85.333333 0 0 1 42.666667 73.898667v377.386666a85.333333 85.333333 0 0 1-42.666667 73.898667L554.666667 963.306667a85.333333 85.333333 0 0 1-85.333334 0L142.506667 774.592a85.333333 85.333333 0 0 1-42.666667-73.898667v-377.386666a85.333333 85.333333 0 0 1 42.666667-73.898667z m42.666667 73.898667L185.173333 323.306667v377.386666L512 889.408l326.826667-188.714667v-377.386666L512 134.592zM512 341.333333a170.666667 170.666667 0 1 1 0 341.333334 170.666667 170.666667 0 0 1 0-341.333334z m0 85.333334a85.333333 85.333333 0 1 0 0 170.666666 85.333333 85.333333 0 0 0 0-170.666666z"
              fill="#999999" p-id="3599"></path>
          </svg> <svg t="1776759085485" class="md:hidden block icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="3598" width="16" height="16">
            <path
              d="M469.333333 60.693333a85.333333 85.333333 0 0 1 85.333334 0l326.826666 188.714667a85.333333 85.333333 0 0 1 42.666667 73.898667v377.386666a85.333333 85.333333 0 0 1-42.666667 73.898667L554.666667 963.306667a85.333333 85.333333 0 0 1-85.333334 0L142.506667 774.592a85.333333 85.333333 0 0 1-42.666667-73.898667v-377.386666a85.333333 85.333333 0 0 1 42.666667-73.898667z m42.666667 73.898667L185.173333 323.306667v377.386666L512 889.408l326.826667-188.714667v-377.386666L512 134.592zM512 341.333333a170.666667 170.666667 0 1 1 0 341.333334 170.666667 170.666667 0 0 1 0-341.333334z m0 85.333334a85.333333 85.333333 0 1 0 0 170.666666 85.333333 85.333333 0 0 0 0-170.666666z"
              fill="#999999" p-id="3599"></path>
          </svg> <span class="text-[#999] md:text-base text-[16px]">菌丰新闻</span> </div>
        <div class="flex items-center gap-4"> <!-- 返回按钮样式对齐设计图：< 返回 箭头+文字 --> <button @click="$router.go(-1)"
            class="text-[#999] md:text-base text-[16px] flex items-center gap-1"> <span>‹</span> 返回
          </button> <svg t="1776759203352" class="hidden md:block icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="5508" width="32" height="32">
            <path
              d="M826.48 660.9c-60.456 0-109.88 32.358-132.9 82.596L401.373 619.203c17.045-26.404 26.41-58.768 26.41-93.666 0-14.459-1.706-28.943-5.12-42.573l186.572-144.752c24.72 18.729 56.253 29.798 91.177 29.798 84.347 0 147.38-63.012 147.38-146.432 0-83.45-63.054-146.462-147.38-146.462-84.352 0-146.535 63.011-146.535 146.462 0 21.29 4.265 40.868 11.07 57.892L392.837 411.433c-34.068-51.087-90.301-86.856-154.194-86.856-104.192-0.26-188.866 83.989-189.122 188.18a23.803 23.803 0 0 0 0 0.856c-0.2 104.192 84.106 188.815 188.298 189.015h0.83c39.188 0 75.811-10.194 105.635-28.928l335.683 143.032c4.27 79.176 65.602 137.923 146.509 137.923 84.372 0 146.554-62.992 146.554-146.437s-63.058-147.313-146.529-147.313h-0.02z"
              p-id="5509" fill="#999999"></path>
          </svg> <svg t="1776759203352" class="md:hidden block icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="5508" width="16" height="16">
            <path
              d="M826.48 660.9c-60.456 0-109.88 32.358-132.9 82.596L401.373 619.203c17.045-26.404 26.41-58.768 26.41-93.666 0-14.459-1.706-28.943-5.12-42.573l186.572-144.752c24.72 18.729 56.253 29.798 91.177 29.798 84.347 0 147.38-63.012 147.38-146.432 0-83.45-63.054-146.462-147.38-146.462-84.352 0-146.535 63.011-146.535 146.462 0 21.29 4.265 40.868 11.07 57.892L392.837 411.433c-34.068-51.087-90.301-86.856-154.194-86.856-104.192-0.26-188.866 83.989-189.122 188.18a23.803 23.803 0 0 0 0 0.856c-0.2 104.192 84.106 188.815 188.298 189.015h0.83c39.188 0 75.811-10.194 105.635-28.928l335.683 143.032c4.27 79.176 65.602 137.923 146.509 137.923 84.372 0 146.554-62.992 146.554-146.437s-63.058-147.313-146.529-147.313h-0.02z"
              p-id="5509" fill="#999999"></path>
          </svg> <!-- 设计图无右侧⇄按钮，直接移除 --> </div>
      </div> <!-- 新闻标题（完全对齐设计图：绿色、居中、字号加粗） -->
      <h2 class="md:text-3xl text-[16px] font-bold text-[#41B56F] text-center mb-8"> 中国已成为全球最大食用菌生产国与消费国
      </h2> <!-- 正文内容（完全对齐设计图排版、行距、图片、注释、底部编辑） -->
      <div class="text-[#000] md:text-xl text-[14px] tracking-wide leading-loose space-y-4 text-gray-600 indent-8">
        <p>
          9月30日，农业农村部发布中华人民共和国农业农村部令2026年第1号，公布《中华人民共和国农业植物品种保护名录（第十二批）》。该名录已经2026年农业农村部第1次部务会议审议通过，自2026年11月1日起施行。本批次共新增117个属（种），其中食用菌及食药用菌物达24个属（种），为历批次中数量最多。至此，累计已有39个食用菌及相关菌物属（种）纳入农业植物品种保护范围。
        </p>
        <p>
          我国食用菌品种保护范围先后经历四次扩容：2005年第六批将白灵侧耳列入，实现食用菌品种保护零的突破；2016年第十批新增羊肚菌属、香菇、黑木耳、灵芝属、双孢蘑菇5个属（种），大宗栽培种类开始成批纳入；2019年第十一批新增金针菇、蛹虫草、猴头菌、毛木耳、真姬菇、平菇、秀珍菇等9个属（种）；2026年第十二批新增24个属（种），竹荪、银耳、草菇、茯苓等特色种类和药用菌资源集中进入保护范围。
        </p>
        <p> 历批累计39个属（种）全清单如下： </p>
        <p class="MsoNormal" align="center" style="text-align:center;"><b><span class="md:text-xl text-[16px]"
              style="font-family: 宋体">历批列入农业植物品种保护名录的食用菌及相关菌物属（种）全清单（截至第十二批）</span></b><b><span
              style="font-family: 宋体; " class="md:text-lg text-xs">
              <o:p></o:p>
            </span></b></p>
        <table class="MsoNormalTable" border="0" cellspacing="0"
          style="border-collapse: collapse; width: 101.64%; border-width: initial; border-style: none; border-color: initial;">
          <tbody>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:1.0000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;background:rgb(237,237,237);">
                <p class="p" align="center" style="margin-bottom:0.0000pt;mso-pagination:widow-orphan;text-align:center;
line-height:125%;"><b><span style="font-family: 黑体; line-height: 125%; " class="md:text-lg text-xs">序号</span></b><span
                    style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:1.0000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;background:rgb(237,237,237);">
                <p class="p" align="center" style="margin-bottom:0.0000pt;mso-pagination:widow-orphan;text-align:center;
line-height:125%;"><b><span style="font-family: 黑体; line-height: 125%; "
                      class="md:text-lg text-xs">属或种名</span></b><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:1.0000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;background:rgb(237,237,237);">
                <p class="p" align="center" style="margin-bottom:0.0000pt;mso-pagination:widow-orphan;text-align:center;
line-height:125%;"><b><span style="font-family: 黑体; line-height: 125%; " class="md:text-lg text-xs">学名</span></b><span
                    style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:1.0000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;background:rgb(237,237,237);">
                <p class="p" align="center" style="margin-bottom:0.0000pt;mso-pagination:widow-orphan;text-align:center;
line-height:125%;"><b><span style="font-family: 黑体; line-height: 125%; "
                      class="md:text-lg text-xs">列入批次</span></b><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">1</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">白灵侧耳</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Pleurotus nebrodensis&nbsp;(Inzenga) Quél.</span><span class="md:text-lg text-[14px]"
                    style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第六批（</font>
                    <font face="宋体">2005年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">2</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">羊肚菌属</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Morchella&nbsp;Dill. ex Pers.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十批（</font>
                    <font face="宋体">2016年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">3</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">香菇</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Lentinula edodes&nbsp;(Berk.) Pegler</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十批（</font>
                    <font face="宋体">2016年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">4</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">黑木耳</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Auricularia heimuer&nbsp;F. Wu, B.K. Cui &amp; Y.C. Dai</span><span
                    class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十批（</font>
                    <font face="宋体">2016年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">5</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">灵芝属</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Ganoderma&nbsp;P. Karst.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十批（</font>
                    <font face="宋体">2016年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">6</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">双孢蘑菇</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Agaricus bisporus&nbsp;(J.E. Lange) Imbach</span><span class="md:text-lg text-[14px]"
                    style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十批（</font>
                    <font face="宋体">2016年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">7</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">金针菇</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Flammulina velutipes&nbsp;(Curtis) Singer</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十一批（</font>
                    <font face="宋体">2019年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">8</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">蛹虫草</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Cordyceps militaris&nbsp;(L. ex Fr.) Link</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十一批（</font>
                    <font face="宋体">2019年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">9</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">长根菇</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Hymenopellis raphanipes&nbsp;(Berk.) R.H. Petersen</span><span
                    class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十一批（</font>
                    <font face="宋体">2019年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">10</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">猴头菌</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Hericium erinaceus&nbsp;(Bull.) Pers.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十一批（</font>
                    <font face="宋体">2019年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">11</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">毛木耳</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Auricularia cornea&nbsp;Ehrenb.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十一批（</font>
                    <font face="宋体">2019年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">12</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">蝉花</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Isaria cicadae&nbsp;Miquel</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十一批（</font>
                    <font face="宋体">2019年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">13</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">真姬菇</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Hypsizygus marmoreus&nbsp;(Peck) H.E. Bigelow</span><span class="md:text-lg text-[14px]"
                    style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十一批（</font>
                    <font face="宋体">2019年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">14</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">平菇（糙皮侧耳、佛罗里达侧耳）</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Pleurotus ostreatus&nbsp;(Jacq.) P. Kumm. &amp;&nbsp;Pleurotus
                    floridanus&nbsp;Singer</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十一批（</font>
                    <font face="宋体">2019年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">15</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">秀珍菇（肺形侧耳）</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Pleurotus pulmonarius&nbsp;(Fr.) Quél.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十一批（</font>
                    <font face="宋体">2019年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">16</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">茶薪菇</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Cyclocybe chaxingu&nbsp;(N. L. Huang) Q. M. Liu, Yang Gao &amp; D. M. Hu</span><span
                    class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">17</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">皱木耳</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Auricularia delicata (Mont.) Henn.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">18</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">中华腐生牛肝菌</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Buchwaldoboletus xylophilus (Petch) Both &amp; B. Ortiz</span><span
                    class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">19</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">虫草属</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Cordyceps Fr.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">20</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">毛头鬼伞（鸡腿菇）</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Coprinus comatus (O. F. Müll.) Pers.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">21</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">榆耳</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Gloeostereum incarnatum S. Ito &amp; S. Imai</span><span class="md:text-lg text-[14px]"
                    style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">22</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">灰树花</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Grifola frondosa (Dicks.) Gray</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">23</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">珊瑚状猴头菌</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Hericium coralloides (Scop.) Pers.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">24</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">荷叶离褶伞（鹿茸菇）</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Lyophyllum decastes (Fr.) Singer</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">25</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">鬼笔属（含竹荪、冬荪）</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Phallus Junius ex L.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">26</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">金顶侧耳</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Pleurotus citrinopileatus Singer</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">27</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">刺芹侧耳（杏鲍菇）</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Pleurotus eryngii (DC.) Quél.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">28</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">巨大侧耳（猪肚菇）</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Pleurotus giganteus (Berk.) Karun. &amp; K. D. Hyde</span><span
                    class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">29</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">暗褐脉柄牛肝菌</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Phlebopus portentosus (Berk. &amp; Broome) Boedijn</span><span
                    class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">30</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">桑黄孔菌属</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Sanghuangporus Sheng H. Wu, L.W. Zhou &amp; Y. C. Dai</span><span
                    class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">31</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">海绵胶煤炱菌（竹燕窝）</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Scorias spongiosa (Schwein.) Fr.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">32</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">元蘑</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Sarcomyxa edulis (Y. C. Dai, Niemelä &amp; G. F. Qin) T. Saito, Tonouchi &amp; T.
                    Harada</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">33</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">裂褶菌</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Schizophyllum commune Fr.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">34</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">广叶绣球菌</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Sparassis latifolia Y. C. Dai &amp; Zheng Wang</span><span class="md:text-lg text-[14px]"
                    style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">35</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">大球盖菇</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Stropharia rugosoannulata Farl. ex Murrill</span><span class="md:text-lg text-[14px]"
                    style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">36</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">银耳</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Tremella fuciformis Berk.</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">37</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">金耳</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Naematelia aurantialba (Bandoni &amp; M. Zang) Millanes &amp; Wedin</span><span
                    class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">38</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">草菇</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Volvariella volvacea (Bull.) Singer</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
            <tr>
              <td width="43" valign="top" style="width:32.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:1.0000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">39</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="143" valign="top" style="width:107.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">茯苓</span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="245" valign="top" style="width:183.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">Wolfiporia cocos (F. A. Wolf) Ryvarden &amp; Gilb.</span><span
                    class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
              <td width="145" valign="top" style="width:108.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:1.0000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:1.0000pt solid windowtext;">
                <p class="MsoNormal"><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <font face="宋体">第十二批（</font>
                    <font face="宋体">2026年）</font>
                  </span><span class="md:text-lg text-[14px]" style="font-family:宋体;line-height:125%;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></p>
              </td>
            </tr>
          </tbody>
        </table> <!-- 底部编辑信息（对齐设计图：靠右、格式、文字） -->
        <div class="text-right md:text-base text-[16px] text-[#999] mt-12"> <i class="el-icon-edit-outline"></i>
          <span>编辑 菌丰生物</span> </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "NewsDetailPage", data() { return { id: 1, }; }, mounted() {    // 页面加载时滚动到顶部
    this.id = this.$route.query.id;
  },
}</script>
<style scoped>
/* 基础过渡效果 */
img {
  transition: transform 0.3s ease;
}

img:hover {
  transform: scale(1.02);
}

button {
  border: none;
  background: transparent;
  cursor: pointer;
}
</style>